
      // 统一使用VITE_NODE_ENV（和env.js取值来源一致）
      window.__APP_ENV__ = {
        NODE_ENV: import.meta.env.VITE_NODE_ENV || 'development', // 优先取自定义的VITE_NODE_ENV
        VITE_MOCK_ENABLE: import.meta.env.VITE_MOCK_ENABLE === 'true' || false
      };
      // 测试+生产环境禁用F12/右键（符合规则41/29）
      if (window.__APP_ENV__.NODE_ENV === 'production' || window.__APP_ENV__.NODE_ENV === 'test') {
        document.addEventListener('contextmenu', e => e.preventDefault());
        document.addEventListener('keydown', e => {
          // 补充：阻止事件冒泡，避免浏览器默认行为被覆盖
          if (e.key === 'F12' || (e.ctrlKey && e.shiftKey && e.key === 'I')) {
            e.preventDefault();
            e.stopImmediatePropagation(); // 新增：阻止其他监听覆盖
          }
        });
      }
      import('./src/main.js');
    